import { AxiosError } from "axios";

export class AxiosUtils {
    public static getErrors(error: AxiosError) {
        let errors: any = {};
        if (error && error.response && error.response.data && (error.response.data as any).errors) {
            errors = (error.response.data as any).errors;
        }
        return errors;
    }

    public static getStatus(error: AxiosError) {
        if (error && error.response) {
            return error.response.status;
        }
        return 500; // Default error status
    }
}